import { render, staticRenderFns } from "./EditDialogPrixClient.vue?vue&type=template&id=66995fc8&"
import script from "./EditDialogPrixClient.vue?vue&type=script&lang=ts&"
export * from "./EditDialogPrixClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports